export interface RealEstateStyle {
  image: string;
  gradient: {
    from: string;
    via?: string;
    to: string;
    border: string;
  };
}

const STYLE_MAP: Record<number, RealEstateStyle> = {
  1: {
    image: '/game-assets/map-objects/real-estate/1.webp',
    gradient: {
      from: 'var(--color-real-estate-1-from)',
      via: 'var(--color-real-estate-1-via)',
      to: 'var(--color-real-estate-1-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  2: {
    image: '/game-assets/map-objects/real-estate/2.webp',
    gradient: {
      from: 'var(--color-real-estate-2-from)',
      via: 'var(--color-real-estate-2-via)',
      to: 'var(--color-real-estate-2-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  3: {
    image: '/game-assets/map-objects/real-estate/3.webp',
    gradient: {
      from: 'var(--color-real-estate-3-from)',
      via: 'var(--color-real-estate-3-via)',
      to: 'var(--color-real-estate-3-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  4: {
    image: '/game-assets/map-objects/real-estate/4.webp',
    gradient: {
      from: 'var(--color-real-estate-4-from)',
      via: 'var(--color-real-estate-4-via)',
      to: 'var(--color-real-estate-4-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  5: {
    image: '/game-assets/map-objects/real-estate/5.webp',
    gradient: {
      from: 'var(--color-real-estate-5-from)',
      via: 'var(--color-real-estate-5-via)',
      to: 'var(--color-real-estate-5-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  6: {
    image: '/game-assets/map-objects/real-estate/6.webp',
    gradient: {
      from: 'var(--color-real-estate-6-from)',
      via: 'var(--color-real-estate-6-via)',
      to: 'var(--color-real-estate-6-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  7: {
    image: '/game-assets/map-objects/real-estate/7.webp',
    gradient: {
      from: 'var(--color-real-estate-7-from)',
      via: 'var(--color-real-estate-7-via)',
      to: 'var(--color-real-estate-7-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  8: {
    image: '/game-assets/map-objects/real-estate/8.webp',
    gradient: {
      from: 'var(--color-real-estate-8-from)',
      via: 'var(--color-real-estate-8-via)',
      to: 'var(--color-real-estate-8-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  9: {
    image: '/game-assets/map-objects/real-estate/9.webp',
    gradient: {
      from: 'var(--color-real-estate-9-from)',
      via: 'var(--color-real-estate-9-via)',
      to: 'var(--color-real-estate-9-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  10: {
    image: '/game-assets/map-objects/real-estate/10.webp',
    gradient: {
      from: 'var(--color-real-estate-10-from)',
      via: 'var(--color-real-estate-10-via)',
      to: 'var(--color-real-estate-10-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  11: {
    image: '/game-assets/map-objects/real-estate/11.webp',
    gradient: {
      from: 'var(--color-real-estate-11-from)',
      via: 'var(--color-real-estate-11-via)',
      to: 'var(--color-real-estate-11-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  12: {
    image: '/game-assets/map-objects/real-estate/12.webp',
    gradient: {
      from: 'var(--color-real-estate-12-from)',
      via: 'var(--color-real-estate-12-via)',
      to: 'var(--color-real-estate-12-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  13: {
    image: '/game-assets/map-objects/real-estate/13.webp',
    gradient: {
      from: 'var(--color-real-estate-13-from)',
      via: 'var(--color-real-estate-13-via)',
      to: 'var(--color-real-estate-13-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  14: {
    image: '/game-assets/map-objects/real-estate/14.webp',
    gradient: {
      from: 'var(--color-real-estate-14-from)',
      via: 'var(--color-real-estate-14-via)',
      to: 'var(--color-real-estate-14-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  15: {
    image: '/game-assets/map-objects/real-estate/15.webp',
    gradient: {
      from: 'var(--color-real-estate-15-from)',
      via: 'var(--color-real-estate-15-via)',
      to: 'var(--color-real-estate-15-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  16: {
    image: '/game-assets/map-objects/real-estate/16.webp',
    gradient: {
      from: 'var(--color-real-estate-16-from)',
      via: 'var(--color-real-estate-16-via)',
      to: 'var(--color-real-estate-16-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  17: {
    image: '/game-assets/map-objects/real-estate/17.webp',
    gradient: {
      from: 'var(--color-real-estate-17-from)',
      via: 'var(--color-real-estate-17-via)',
      to: 'var(--color-real-estate-17-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  18: {
    image: '/game-assets/map-objects/real-estate/18.webp',
    gradient: {
      from: 'var(--color-real-estate-18-from)',
      via: 'var(--color-real-estate-18-via)',
      to: 'var(--color-real-estate-18-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  19: {
    image: '/game-assets/map-objects/real-estate/19.webp',
    gradient: {
      from: 'var(--color-real-estate-19-from)',
      via: 'var(--color-real-estate-19-via)',
      to: 'var(--color-real-estate-19-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  20: {
    image: '/game-assets/map-objects/real-estate/20.webp',
    gradient: {
      from: 'var(--color-real-estate-20-from)',
      via: 'var(--color-real-estate-20-via)',
      to: 'var(--color-real-estate-20-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  21: {
    image: '/game-assets/map-objects/real-estate/21.webp',
    gradient: {
      from: 'var(--color-real-estate-21-from)',
      via: 'var(--color-real-estate-21-via)',
      to: 'var(--color-real-estate-21-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  22: {
    image: '/game-assets/map-objects/real-estate/22.webp',
    gradient: {
      from: 'var(--color-real-estate-22-from)',
      via: 'var(--color-real-estate-22-via)',
      to: 'var(--color-real-estate-22-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  23: {
    image: '/game-assets/map-objects/real-estate/23.webp',
    gradient: {
      from: 'var(--color-real-estate-23-from)',
      via: 'var(--color-real-estate-23-via)',
      to: 'var(--color-real-estate-23-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  24: {
    image: '/game-assets/map-objects/real-estate/24.webp',
    gradient: {
      from: 'var(--color-real-estate-24-from)',
      via: 'var(--color-real-estate-24-via)',
      to: 'var(--color-real-estate-24-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  25: {
    image: '/game-assets/map-objects/real-estate/25.webp',
    gradient: {
      from: 'var(--color-real-estate-25-from)',
      via: 'var(--color-real-estate-25-via)',
      to: 'var(--color-real-estate-25-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  26: {
    image: '/game-assets/map-objects/real-estate/26.webp',
    gradient: {
      from: 'var(--color-real-estate-26-from)',
      via: 'var(--color-real-estate-26-via)',
      to: 'var(--color-real-estate-26-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  27: {
    image: '/game-assets/map-objects/real-estate/27.webp',
    gradient: {
      from: 'var(--color-real-estate-27-from)',
      via: 'var(--color-real-estate-27-via)',
      to: 'var(--color-real-estate-27-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  28: {
    image: '/game-assets/map-objects/real-estate/28.webp',
    gradient: {
      from: 'var(--color-real-estate-28-from)',
      via: 'var(--color-real-estate-28-via)',
      to: 'var(--color-real-estate-28-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  29: {
    image: '/game-assets/map-objects/real-estate/29.webp',
    gradient: {
      from: 'var(--color-real-estate-29-from)',
      via: 'var(--color-real-estate-29-via)',
      to: 'var(--color-real-estate-29-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  // NEW Bikini Bottom Box houses (30-32)
  30: {
    image: '/game-assets/map-objects/real-estate/30.webp',
    gradient: {
      from: 'var(--color-real-estate-30-from)',
      via: 'var(--color-real-estate-30-via)',
      to: 'var(--color-real-estate-30-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  31: {
    image: '/game-assets/map-objects/real-estate/31.webp',
    gradient: {
      from: 'var(--color-real-estate-31-from)',
      via: 'var(--color-real-estate-31-via)',
      to: 'var(--color-real-estate-31-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  32: {
    image: '/game-assets/map-objects/real-estate/32.webp',
    gradient: {
      from: 'var(--color-real-estate-32-from)',
      via: 'var(--color-real-estate-32-via)',
      to: 'var(--color-real-estate-32-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  // Egypt Box houses (33-35)
  33: {
    image: '/game-assets/map-objects/real-estate/33.webp',
    gradient: {
      from: 'var(--color-real-estate-33-from)',
      via: 'var(--color-real-estate-33-via)',
      to: 'var(--color-real-estate-33-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  34: {
    image: '/game-assets/map-objects/real-estate/34.webp',
    gradient: {
      from: 'var(--color-real-estate-34-from)',
      via: 'var(--color-real-estate-34-via)',
      to: 'var(--color-real-estate-34-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
  35: {
    image: '/game-assets/map-objects/real-estate/35.webp',
    gradient: {
      from: 'var(--color-real-estate-35-from)',
      via: 'var(--color-real-estate-35-via)',
      to: 'var(--color-real-estate-35-to)',
      border: 'var(--color-real-estate-card-border)',
    },
  },
};

const DEFAULT_STYLE: RealEstateStyle = {
  image: '/game-assets/map-objects/real-estate/1.webp',
  gradient: {
    from: 'var(--color-real-estate-default-from)',
    via: 'var(--color-real-estate-default-via)',
    to: 'var(--color-real-estate-default-to)',
    border: 'var(--color-real-estate-card-border)',
  },
};

export const getRealEstateStyle = (id: number): RealEstateStyle =>
  STYLE_MAP[id] ?? DEFAULT_STYLE;

// Centralized real estate names and descriptions
// These functions accept a translation function `t` to support i18n
export const getRealEstateName = (id: number, t: (key: string) => string): string => {
  const names: Record<number, string> = {
    1: t("Island Cottage"),
    2: t("Seaside Hut"),
    3: t("Harbor House"),
    4: t("Sunset Lodge"),
    5: t("Palm Cabin"),
    6: t("Palm Cabin"),
    7: t("Tropical Veranda House"),
    8: t("Tropical Deck Residence"),
    9: t("Island Porch House"),
    10: t("Island Veranda Cottage"),
    11: t("Grand Island Manor"),
    12: t("Golden Island Estate"),
    13: t("Cat Cottage"),
    14: t("Tiki Lodge"),
    15: t("Whisker Canopy"),
    16: t("Bubble Star Hut"),
    17: t("Ancient Reef Home"),
    18: t("Sunny Pine Home"),
    19: t("Purr Palace"),
    20: t("Seaside Rest Hut"),
    21: t("Lantern Breeze Home"),
    22: t("Blooming Island House"),
    23: t("Quiet Shore House"),
    24: t("Leafy Haven"),
    25: t("Glass Garden House"),
    26: t("Old Tide House"),
    27: t("Sunset Pier Villa"),
    28: t("High Council Manor"),
    29: t("Founder's Timber Residence"),
    30: t("Chum Bucket Laboratory"),
    31: t("Krabby Shack Grill"),
    32: t("Treedome Research Habitat"),
    33: t("Temple of the Desert Scribe"),
    34: t("Palace of the Sun Pharaoh"),
    35: t("Golden Oasis Citadel"),
  };
  return names[id] || t(`House ${id}`);
};

export const getRealEstateDescription = (id: number, t: (key: string) => string): string => {
  const descriptions: Record<number, string> = {
    1: t("A cozy wooden beach house with a bright tiled roof. Perfect for starting your island settlement and relaxing by the shore"),
    2: t("A small sandy hut with a thatched roof and bright shutters. Ideal for a cozy start on your island and perfect for beachfront living"),
    3: t("A bright seaside home with a wide wooden deck and ocean-themed decor. Perfect for islanders who love space, sunlight, and coastal views"),
    4: t("A spacious two-story island lodge with wide balconies and warm tiled roofs. Great for players who want comfort, views, and room to grow on their island."),
    5: t("A cozy wooden cabin with a palm tree and a shaded porch. Perfect for relaxed island living and settling close to the shoreline."),
    6: t("A cozy wooden cabin with a palm tree and a shaded porch. Perfect for relaxed island living and settling close to the shoreline."),
    7: t("A two-story wooden island house with wide verandas and a thatched roof. Perfect for enjoying ocean views, fresh air, and relaxed island living."),
    8: t("A bright island residence with multiple balconies, curved architecture, and tropical accents. Designed to stand out with its unique shape and spacious outdoor areas."),
    9: t("A compact wooden island house with a thatched roof and a cozy front porch. Perfect for relaxed island living and a warm, welcoming atmosphere."),
    10: t("A charming wooden island house with a covered porch and tropical plants. Great for creating a welcoming and lively island space."),
    11: t("A magnificent island manor with towers, layered terraces, and rich wooden details. Designed to impress with its scale, elegant architecture, and vibrant island atmosphere."),
    12: t("A breathtaking island estate with layered towers, cascading terraces, and elegant wooden walkways. Every level is filled with detail, color, and space, creating a truly unforgettable island home."),
    13: t("A warm island cabin with a sleepy cat roof, wooden platforms, and blooming plants all around. Ideal for slow days, gentle vibes, and peaceful island life."),
    14: t("A welcoming beach hut with hanging lanterns, wooden decks, and soft firelight. A great home for calm nights and peaceful island living."),
    15: t("A cozy treetop home with a round cat roof, glowing windows, and wooden stairs. Made for calm moments, fresh air, and charming island views."),
    16: t("A playful seaside cottage shaped like a bright starfish, surrounded by sea plants and bubbles. Perfect for fun island living with a splash of ocean charm."),
    17: t("A timeless stone home inspired by ocean ruins and deep-sea legends. Built for players who love mystery and solid island vibes."),
    18: t("A cozy pineapple hut inspired by life beneath the waves, with bright colors and soft shapes. Made for lighthearted fun and happy island adventures."),
    19: t("A stunning treehouse crowned with a golden cat face, surrounded by flowers and warm lights. Designed for premium comfort and magical island living."),
    20: t("A cozy seaside hut with soft wooden textures, glowing lanterns, and a shaded porch. Ideal for unwinding and enjoying calm island life."),
    21: t("A beautiful two-level tropical house with open balconies, hanging lights, and lush plants. Perfect for relaxing and enjoying island views."),
    22: t("A beautiful island house covered in flowers, with straw roofs, cozy balconies, and warm hanging lights. Perfect for relaxed living surrounded by color and nature."),
    23: t("A peaceful seaside house with small fish details and a rooster weather vane watching over the roof. Perfect for slow, quiet living by the sea and moments of calm solitude."),
    24: t("A charming home with leafy roofs, blooming plants, and soft glowing windows. Made for peaceful days, gentle evenings, and natural island beauty."),
    25: t("A calm island home with glass framing, leafy plants, and an open airy feel. Designed to let nature stay close at every moment."),
    26: t("A solid and inviting home with aged wood tones, steady structure, and a calm shoreline presence. Designed to feel safe while hinting at the sea's quiet depth."),
    27: t("A two-level tropical villa standing above the water, wrapped in warm wood and ocean air. Fruit baskets, surfboards, open balconies — this is not survival housing. This is visible success. Players passing by instantly recognize the lifestyle."),
    28: t("Stone walls, gothic windows, iron rooftop details. This residence feels institutional, influential, and permanent. It does not belong to beginners — it belongs to those shaping the island's direction."),
    29: t("Classic craftsmanship with warm timber walls, detailed roofing, and balcony charm. It signals stability and earned prosperity. Not flashy — established. The kind of home that suggests long-term presence and growing influence."),
    30: t("A notorious underwater establishment known for bold culinary experiments and questionable recipes. Rumor says brilliant ideas are born here — even if the results are… unusual. A legendary landmark for those who appreciate chaotic genius."),
    31: t("The most famous underwater grill house where secret recipes turn into ocean legends. Every visitor knows the place, every competitor envies it. Owning this building means owning a piece of undersea culinary history."),
    32: t("A sealed scientific habitat where land technology meets underwater curiosity. Inside, experiments reshape what is possible beneath the waves. A perfect structure for players who value intelligence, invention, and bold ideas."),
    33: t("A sandstone sanctuary decorated with ancient symbols and scholars' relics. Here knowledge was preserved and wisdom recorded. A residence worthy of those who respect intellect and ancient tradition."),
    34: t("A magnificent desert palace crowned with statues, terraces, and glowing firelight. Built for rulers who command both wealth and reverence. This residence transforms any land into royal territory."),
    35: t("A fortified desert citadel rising above palm gardens and sandstone walls. Part fortress, part palace — a symbol of stability and enduring power. Those who dwell here rule their domain with confidence."),
  };
  return descriptions[id] || '';
};
